import {
  FLOW_SET_NAME,
  FLOW_SET_E2EFLOW,
  FLOW_SET_STATE_NAME,
  FLOW_SET_STATE_TRANSITIONS,
  FLOW_SET_STATE_VIEW_CONTENT,
  FLOW_SET_STATE_VIEW_OPTIONS,
  FLOW_SET_COMPANY_ICON,
  FLOW_SET_ERROR,
  FLOW_SET_COMPANY,
  FLOW_SET_COMPANY_COLOR
} from './types'

export default {
  [FLOW_SET_NAME](state, payload) {
    state.flowName = payload
  },

  [FLOW_SET_E2EFLOW](state, payload) {
    state.e2eFlow = payload
  },

  [FLOW_SET_COMPANY_ICON](state, payload) {
    state.flowCompanyIcon = payload
  },

  [FLOW_SET_STATE_NAME](state, payload) {
    state.flowState = payload
  },

  [FLOW_SET_STATE_TRANSITIONS](state, payload) {
    state.flowTransitions = payload
  },

  [FLOW_SET_STATE_VIEW_CONTENT](state, payload) {
    state.flowViewContent = payload
  },

  [FLOW_SET_STATE_VIEW_OPTIONS](state, payload) {
    state.flowViewOptions = payload
  },

  [FLOW_SET_ERROR](state, payload) {
    state.flowError = payload
  },
  [FLOW_SET_COMPANY](state, payload) {
    state.flowCompany = payload
  },
  [FLOW_SET_COMPANY_COLOR](state, payload) {
    state.flowCompanyColor = payload
  }
}
